module.exports = __webpack_public_path__ + "static/img/wuxrc.4f3ee09.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bank/wuxrc.png
// module id = 3+B6
// module chunks = 93